export default "__VITE_ASSET__B52mYYN1__"